import { Component,OnInit, ViewChild, ElementRef,inject } from '@angular/core';
import { ChartType, ChartOptions,ChartDataSets, RadialChartOptions } from 'chart.js';
import { SingleDataSet, Label, monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip } from 'ng2-charts';
import { DatePipe } from '@angular/common';
import { MatTableDataSource } from '@angular/material/table';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { PatientDetailModel } from 'app/opdvisits/Models/patient_details.model';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { ExportService } from 'app/reports/services/export.service';
import { AuthService } from 'app/auth/auth.service';
import { MatCheckboxChange } from '@angular/material/checkbox';


@Component({
  selector: 'app-pre-operative-assesment-sheet',
  templateUrl: './pre-operative-assesment-sheet.component.html',
  styleUrls: ['./pre-operative-assesment-sheet.component.scss']
})
export class PreOperativeAssesmentSheetComponent implements OnInit {
  selectDateString: string = '';
  startdate: any;
  enddate: any;
  isShowDivIf: boolean = false;



  constructor(private authservice: AuthService, public dashboardService: DashboardService, public exportdata: ExportService, public datePipe: DatePipe) { }

  ngOnInit(): void {
    this.startdate = this.dashboardService.selecteddate;
    this.enddate = this.dashboardService.selecteddate;


      
  }
  
  
  changedateField(event) {

    this.selectDateString = event;
  }

  filterFinalData() {
    if (Date.parse(this.datePipe.transform(this.enddate, "yyyy-MM-dd").toString()) >= Date.parse(this.datePipe.transform(this.startdate, "yyyy-MM-dd").toString())) {
      // if (this.reportAccessName) {
      //   let payload = {
      //     "MisReportmaster": {
      //       "viewname": this.reportAccessName,
      //       "DateColumnName": this.selectDateString,
      //       "ToDate": this.datePipe.transform(this.enddate, "yyyy-MM-dd"),
      //       "FromDate": this.datePipe.transform(this.startdate, "yyyy-MM-dd"),
      //     },
      //     "MisReportMasterDataArray": this.changeColumnArray
      //   }
      //   this.getReportdataView(payload);
      // } else {
      //   this.dashboardService.openSnackBar("Select Report First", "OK");
      // }
    } else {
      this.dashboardService.openSnackBar("Please Select Correct Date Range  ", "OK");
    }



  }

  isHeader(event: MatCheckboxChange) {
    this.isShowDivIf = event.checked;
  }

  // isHeaderSelectAll(event: MatCheckboxChange) {
  //   if (event.checked == true) {

  //     this.ColumnViewArray.forEach((item, i) => {
  //       this.ColumnViewArray[i].values = true;
  //     });

  //     this.headerFieldarray = this.ColumnViewArray;
  //   }
  // }


  // public openPDF(): void {
  //   if (this.headerFieldarray.length != 0) {
  //     if (this.headerFieldarray.length <= 13) {
  //       this.exportdata.open_loader_Dialogtwo();
  //       $("#content").removeClass("table-block");
  //       let DATA = document.getElementById('content');
  //       this.exportdata.getexportPDF(DATA, this.displayName);

  //       $("#content").addClass("table-block");

  //     } else {
  //       this.dashboardService.openSnackBar("You Can't Export PDF More than 13 Column", "OK");
  //     }
  //   }
  // }


  // public openPDF(): void {
  //   if (this.headerFieldarray.length != 0) {
  //     if (this.headerFieldarray.length <= 13) {
  //       this.exportdata.open_loader_Dialogtwo();
  //       $("#content").removeClass("table-block");
  //       let DATA = document.getElementById('content');
  //       this.exportdata.getexportPDF(DATA, this.displayName);

  //       $("#content").addClass("table-block");

  //     } else {
  //       this.dashboardService.openSnackBar("You Can't Export PDF More than 13 Column", "OK");
  //     }
  //   }
  
  // }


  // exportexcel() {
  //   this.exportdata.open_loader_Dialogtwo();
  //   let element = document.getElementById('content');
  //   this.exportdata.Newexportxcel(element, "new");

  // }


  public printPDF(): void {
  
        this.exportdata.printpDFData();
    
    }
  
 
  }
  
